import {NodeType, ServerNode} from 'common/src/modules/nodes/nodes.types';
import {DTNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {serializeFacebookDPACreative} from 'common/src/modules/campaigns/utils/serializeFacebookDPACreative';
import {serializeWeightedNode} from 'common/src/modules/campaigns/utils/serializeWeightedNode';
import {serializeDistributionNode} from 'common/src/modules/campaigns/utils/serializeDistributionNode';
import {serializeSequenceNode} from 'common/src/modules/campaigns/utils/serializeSequenceNode';
import {serializeProductsNode} from 'common/src/modules/campaigns/utils/serializeProductsNode';
import {serializeConditionNode} from 'common/src/modules/campaigns/utils/serializeConditionNode';
import {serializeCompoundConditionNode} from 'common/src/modules/campaigns/utils/serializeCompoundConditionNode';
import {serializeStoreNode} from 'common/src/modules/campaigns/utils/serializeStoreNode';
import {serializeOptimizationNode} from 'common/src/modules/campaigns/utils/serializeOptimizationNode';
import {serializeScheduleNode} from 'common/src/modules/campaigns/utils/serializeScheduleNode';
import {
  serializeConceptCreativeNode,
  serializeCreativeNode,
} from 'common/src/modules/campaigns/utils/serializeConceptCreativeNode';
import {serializeNativeCreativeNode} from 'common/src/modules/campaigns/utils/serializeNativeCreativeNode';
import {serializeYoutubeCreativeNode} from 'common/src/modules/campaigns/utils/serializeYoutubeCreativeNode';
import {serializeSnapchatCreativeNode} from 'common/src/modules/campaigns/utils/serializeSnapchatCreativeNode';
import {serializeSocialCarouselNode} from 'common/src/modules/campaigns/utils/serializeSocialCarouselNode';
import {serializeFacebookDPACarouselCreative} from 'common/src/modules/campaigns/utils/serializeFacebookDPACarouselCreative';
import serializeContentNode from 'common/src/modules/campaigns/utils/serializeContentNode';
import {serializeLinkedInCreativeNode} from './serializeLinkedInCreativeNode';
import {serializeTiktokCreativeNode} from './serializeTiktokCreativeNode';
import {serializeFacebookCreativeNode} from './serializeFacebookCreativeNode';

type Serializers = Record<NodeType, (node: DTNode, newNode: ServerNode) => ServerNode>;

const nodeSerializers: Serializers = {
  [NodeType.WEIGHTED]: serializeWeightedNode,
  [NodeType.DISTRIBUTION]: serializeDistributionNode,
  [NodeType.CONDITION]: serializeConditionNode,
  [NodeType.COMPOUND_CONDITION]: serializeCompoundConditionNode,
  [NodeType.PRODUCTS]: serializeProductsNode,
  [NodeType.STORE]: serializeStoreNode,
  [NodeType.GENERAL_OPTIMIZATION]: serializeOptimizationNode,
  [NodeType.SCHEDULE]: serializeScheduleNode,
  [NodeType.CREATIVE]: serializeCreativeNode,
  [NodeType.CONCEPT_CREATIVE]: serializeConceptCreativeNode,
  [NodeType.NATIVE_CREATIVE]: serializeNativeCreativeNode,
  [NodeType.SOCIAL_FACEBOOK_AD_CREATIVE]: serializeFacebookCreativeNode,
  [NodeType.SOCIAL_TIKTOK_AD_CREATIVE]: serializeTiktokCreativeNode,
  [NodeType.SOCIAL_YOUTUBE_AD_CREATIVE]: serializeYoutubeCreativeNode,
  [NodeType.SOCIAL_YOUTUBE_DV360_AD_CREATIVE]: serializeYoutubeCreativeNode,
  [NodeType.SOCIAL_SNAPCHAT_AD_CREATIVE]: serializeSnapchatCreativeNode,
  [NodeType.SOCIAL_LINKEDIN_AD_CREATIVE]: serializeLinkedInCreativeNode,
  [NodeType.FACEBOOK_CAROUSEL_CREATIVE]: serializeSocialCarouselNode,
  [NodeType.FACEBOOK_DPA_CAROUSEL_CREATIVE]: serializeFacebookDPACarouselCreative,
  [NodeType.FACEBOOK_DPA_CREATIVE]: serializeFacebookDPACreative,
  [NodeType.SEQUENCE]: serializeSequenceNode,
  [NodeType.CONTENT_FEED]: serializeContentNode,
  [NodeType.CAMPAIGN]: serializeDefaultNode,
  [NodeType.VIDEO_CAMPAIGN]: serializeDefaultNode,
};

function serializeDefaultNode(node: DTNode, newNode: ServerNode): ServerNode {
  return {
    ...node,
    ...newNode,
    outputs: node.outputs || [],
  };
}

export function createDBNode(node: DTNode) {
  const basicNode: ServerNode = {
    id: node.id,
    type: node.type,
    x: node.x,
    y: node.y,
    description: node.description,
    name: node.name,
    outputs: [],
  };

  return nodeSerializers[node.type](node, basicNode);
}

